import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "@app/core/services/base.service";
import { IDataGridPageRequest, ToastService, convertObjectToGetParams, } from "@siu/shared";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { IFormBuscarBandejaVoucherPago, IModeloVoucherPago } from "../pages/bandeja-voucher-pago/store/bandeja-voucher-pago.store.interface";

@Injectable()
export class BandejaVoucherPagoService extends BaseService {
  private urlTPago: string = `${environment.apiGatewayAddress}/t/v1/Pago`;
  private urlGwTransversal: string = `${environment.apiGatewayAddress}/api/v1/Transversal`;

  constructor(private http: HttpClient, toast: ToastService) {
    super(toast);
  }

  buscarBandejaVoucherPago = (
    pageRequest: IDataGridPageRequest,
    filters: any
  ): Observable<any> => {
    const { orderBy: sortField, orderDir: sortDir } = pageRequest;

    const data = {
      ...pageRequest,
      sortField,
      sortDir,
      filter: {
        ...filters
      }
    };

    return this.http.get<any>(`${this.urlGwTransversal}/Buscar-Comprobante-Pago-Bn`, {
      params: convertObjectToGetParams(data)
    });
  };

  fetchBandejaVoucherPagoExcel = (
    pageRequest: IDataGridPageRequest,
    value: IFormBuscarBandejaVoucherPago,
    pageSize: any,
  ): Observable<any> => {

    const Filter = {
      cCodigoAgencia: value.cCodigoAgencia,
      cNumeroSecuencia: value.cNumeroSecuencia,
      cFechaSecuencia: value.cFechaSecuencia,
    };

    const data = { ...pageRequest, PageSize: pageSize, Filter };

    const params = convertObjectToGetParams(data);

    return this.http.get(`${this.urlGwTransversal}/exportar-excel`, {
      params, responseType: "blob" as "json"
    });
  };

  save = (
    voucherPago: IModeloVoucherPago
  ): Observable<any> => {
    return this.http.post(`${this.urlGwTransversal}/Insert-Voucher-Pago-SGD`, voucherPago);
  };

  observation = (
    voucherPago: IModeloVoucherPago
  ): Observable<any> => {
    return this.http.post(`${this.urlTPago}/Insertar-Comprobante-Observado`, voucherPago);
  };

}
